.gp{border:1px solid #ddd;}